/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuestId } from "../../commons/types/GuestId";
import { SpaceId } from "../../commons/types/SpaceId";
export const Invite = core.serialization.object({
    guestId: GuestId,
    spaceId: SpaceId,
    fromName: core.serialization.string().optional(),
    message: core.serialization.string().optional(),
});
